import axios from 'axios';
import qs from 'qs';
import router from '@/router';
import store from '@/store';
import Vue from 'vue';
import { Toast,Dialog } from 'vant';
Vue.use(Toast);
export const baseURL = process.env.NODE_ENV == 'development' ? '/api' : 'https://bm.dahe.cn';
let instance = axios.create({
    baseURL,
    timeout:  1000*60,
    // timeout: 1000 * 10,
    transformRequest: [
        data => {
            if (data) {
                for (let i in data) {
                    if (data[i] === '' || data[i] === null || data[i] === undefined) {
                        delete data[i];
                    }
                }
                //把data转换成formdata
                return qs.stringify(data);
            }
        }
    ]
});
// 添加请求拦截器
instance.interceptors.request.use(
    config => {
        // 登录流程控制中，根据本地是否存在token判断用户的登录情况
        // 但是即使token存在，也有可能token是过期的，所以在每次的请求头中携带token
        // 后台根据携带的token判断用户的登录情况，并返回给我们对应的状态码
        // 而后我们可以在响应拦截器中，根据状态码进行一些统一的操作。
        //设置请求头
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
        try {
            const options = {
                baseURL:config.options.baseURL,
                changeBaseURL:config.options.changeBaseURL,
            }
            if(options.changeBaseURL){
                config.baseURL = options.baseURL
            }
            delete config.options
        } catch (error) {
        }
        // NProgress.start()
        return config;
    },
    error => {
        // 对请求错误做些什么
        return Promise.reject(error);
    }
);

// 添加响应拦截器
instance.interceptors.response.use(
    response => {
        // 对响应数据做点什么
        // NProgress.done()
        if (response.status == 200) {
            if (response.data.result !== 200) {
                if(response.data.result == 0){
                    return response.data;
                }
                if(response.data.result == 500 &&response.data.msg ==  '请重新认证'||response.data.result == 500 &&response.data.msg ==  '认证失败'){
                    Dialog.alert({
                        title: '抱歉',
                        message: '获取微信授权失败',
                    })
                    .then(() => {
                        // on confirm
                        localStorage.clear()
                        let url = encodeURIComponent('https://bm.dahe.cn/wxbanswer/')
                        window.open('https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx90cb4d32ca1105a2&redirect_uri='+url+'&response_type=code&scope=snsapi_userinfo&state=123&connect_redirect=1#wechat_redirect','_self')
                    })
                    .catch(() => {
                        // on cancel
                    });
                    return Promise.reject(response);
                }
                ToastTip(response.data.msg);
                return Promise.reject(response);
            } else {
                return response.data;
            }
        } else {
            errorHandle(response.status);
            return Promise.reject(response);
        }
    },
    error => {
        // 对响应错误做点什么
        errorHandle(error.response.status);
        return Promise.reject(error);
    }
);
const errorHandle = status => {
    // 状态码判断
    switch (status) {
        // 401: 权限不足
        case 401:
            ToastTip('权限不足');
            break;
        // 403 token过期  清除token并跳转登录页
        case 403:
            break;
        // 404请求不存在
        case 404:
            ToastTip('请求不存在');
            break;
        default:
            ToastTip('当前活动过于火爆，请稍后再试');
    }
};
// 跳转登录页  携带当前页面路由，以便在登录页面完成登录后返回当前页面
const toLogin = () => {
    router.replace({
        path: '/'
    });
};
const ToastTip = msg => {
    Toast.fail(msg);
};




export function ajax(url, params={},options={type:'POST',changeBaseURL:false,baseURL:''}) {
    let data = {},param=''
    // 如果不是上传 正常请求
    if (options.type === 'POST') {
        data = params
    } else {
        param = params
        data = {}
    }
    return new Promise((resolve, reject) => {
        return instance({
            method: options.type,
            url:url,
            data:data,
            param:param,
            options
        }).then((response) => {
            resolve(response)
        }).catch((e) => {
            reject(e)
        })
    })
}

export default instance;